import * as React from "react"
const SvgPlug = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.429a.97.97 0 0 1-.713-.288A.97.97 0 0 1 4 20.43v-1a2.1 2.1 0 0 0-.638-.438A.57.57 0 0 1 3 18.43v-3q0-.426.288-.713A.97.97 0 0 1 4 14.43h1v-7q0-1.65 1.175-2.825Q7.35 3.428 9 3.429c1.65.001 2.042.391 2.825 1.175Q13 5.779 13 7.429v10q0 .825.588 1.412.587.588 1.412.588.824 0 1.413-.588.587-.587.587-1.412v-7h-1a.97.97 0 0 1-.713-.288A.97.97 0 0 1 15 9.43v-3a.57.57 0 0 1 .363-.563A2.1 2.1 0 0 0 16 5.43v-1q0-.425.288-.713A.97.97 0 0 1 17 3.43h2q.424 0 .712.287.288.288.288.713v1q.275.275.637.437A.57.57 0 0 1 21 6.43v3q0 .424-.288.712a.97.97 0 0 1-.712.288h-1v7q0 1.65-1.175 2.825T15 21.43c-1.65 0-2.042-.392-2.825-1.175Q11 19.078 11 17.429v-10q0-.825-.588-1.413A1.93 1.93 0 0 0 9 5.43q-.825 0-1.412.587A1.93 1.93 0 0 0 7 7.43v7h1a.97.97 0 0 1 .713.287q.287.288.287.713v3a.57.57 0 0 1-.363.562A2.1 2.1 0 0 0 8 19.43v1a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288H5Z" />
  </svg>
)
export default SvgPlug
